import { useRef, useEffect, useState } from "react";
import { clueTypes } from "../components/courseContent/questionTypes";

export function getFirstClueQuestionKey(courseContent) {
    if (!courseContent) return null;
    return Object.keys(courseContent).find((key) => clueTypes.includes(courseContent[key]?.type)) ?? null;
}

export function useImageLoad(src) {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);
    const imgRef = useRef(null);

    useEffect(() => {
        setLoaded(false);
        setError(false);
        const img = imgRef.current;
        if (img?.complete && img.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [src]);

    return {
        imgRef,
        loaded,
        error,
        onLoad: () => setLoaded(true),
        onError: () => setError(true),
        showSkeleton: !loaded && !error,
    };
}

// Hook
export function useEventListener(eventName, handler, element = window) {
    // Create a ref that stores handler
    const savedHandler = useRef();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    useEffect(
        () => {
            // Make sure element supports addEventListener
            // On
            const isSupported = element && element.addEventListener;
            if (!isSupported) return;
            // Create event listener that calls handler function stored in ref
            const eventListener = (event) => savedHandler.current(event);
            // Add event listener
            element.addEventListener(eventName, eventListener);
            // Remove event listener on cleanup
            return () => {
                element.removeEventListener(eventName, eventListener);
            };
        },
        [eventName, element] // Re-run if eventName or element changes
    );
}
